import { PermissionType } from "@/Enums/PermissionType";
import { IoFileTray, IoPieChart, IoServer, IoDocument } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";

export enum RouteName {
    REQUESTS = 0,
    REQUEST_CATALOG = 1,
    STATISTICS = 2,
    ASSEMBLIES = 3,
    PREVIEW_UPDATE_REQUEST = 4,
    ADD_NEW_REQUEST = 5,
}

export type Route = {
    path: string;
    pathDefinition?: string;
    name: string;
    hiddenInDrawer?: boolean;
    icon: JSX.Element;
    permissionType?: PermissionType;
}

export const routes: Record<RouteName, Route> = {
    [RouteName.REQUESTS]: {
        path: "/request/list",
        pathDefinition: "/request/list/*",
        name: "Zoznam žiadostí",
        icon: <IoFileTray />,
    },
    [RouteName.REQUEST_CATALOG]: {
        path: "/request/catalog",
        name: "Katalóg žiadostí",
        icon: <IoDocument />,
    },
    [RouteName.STATISTICS]: {
        path: "/statistics",
        name: "Štatistiky",
        icon: <IoPieChart />,
        permissionType: PermissionType.READ_STATISTICS
    },
    [RouteName.ASSEMBLIES]: {
        path: "/assemblies",
        name: "Zostavy",
        icon: <IoServer />,
        permissionType: PermissionType.READ_ASSEMBLIES
    },
    [RouteName.PREVIEW_UPDATE_REQUEST]: {
        path: "/request/detail/:requestId",
        name: "Žiadosť",
        icon: <IoDocument />,
        hiddenInDrawer: true,
    },
    [RouteName.ADD_NEW_REQUEST]: {
        path: "/request/new",
        name: "Nová žiadosť",
        icon: <IoDocument />,
        hiddenInDrawer: true,
    },
};

export const useRouter = () => {
    const navigate = useNavigate();

    const location = useLocation();

    const navigateToRequests = () => navigate(routes[RouteName.REQUESTS].path);

    const navigateToRequestCatalog = (q?: string | null, rt?: string | null) => {
        const path = routes[RouteName.REQUEST_CATALOG].path;
        let queryParams = "?";
        if (q) queryParams += `q=${q}`;
        if (rt) queryParams += `&rt=${rt}`;
        navigate(path + queryParams);
    }

    const navigateToPreviewUpdateRequest = (requestId: string, requestType?: string) => {
        let url = routes[RouteName.PREVIEW_UPDATE_REQUEST].path.replace(":requestId", requestId);
        if (requestType) url += `?requestType=${requestType}`;
        navigate(url);
    };

    const navigateToAddNewRequest = (requestType: string) => {
        const url = `${routes[RouteName.ADD_NEW_REQUEST].path}?requestType=${requestType}`;
        navigate(url);
    };

    const navigateToStatistics = () => navigate(routes[RouteName.STATISTICS].path);

    const navigateToAssemblies = () => navigate(routes[RouteName.ASSEMBLIES].path);

    const currentRoute: Route | undefined = Object.values(routes)
        .find((value) => location.pathname === value.path)

    return {
        currentRoute,
        navigateToRequests,
        navigateToRequestCatalog,
        navigateToStatistics,
        navigateToAssemblies,
        navigateToPreviewUpdateRequest,
        navigateToAddNewRequest,
    };
};
